import React from "react";
import Slider from "react-slick"; // Import React Slick
import "slick-carousel/slick/slick.css"; // Import slick styles
import "slick-carousel/slick/slick-theme.css"; // Import slick theme styles
import coming from "../assets/coming.png";
const Partners = () => {
  const partners = [
    { id: 1, src: coming, alt: "Coinbase" }, { id: 1, src: coming, alt: "Coinbase" }, { id: 1, src: coming, alt: "Coinbase" },
    { id: 1, src: coming, alt: "Coinbase" }, { id: 1, src: coming, alt: "Coinbase" }, { id: 1, src: coming, alt: "Coinbase" },
  ];

  const settings = {
    infinite: true, // Loop the slides
    speed: 1500, // Slide transition speed
    slidesToShow: 5, // Number of slides to show
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true, // Enable autoplay
    autoplaySpeed: 0, // No delay between slides
    cssEase: "linear", // Smooth transition effect
    responsive: [
      {
        breakpoint: 1024, // Adjust for tablets
        settings: {
          slidesToShow: 3, // Show 3 slides on tablets
        },
      },
      {
        breakpoint: 600, // Adjust for mobile screens
        settings: {
          slidesToShow: 1, // Show 1 slide on mobile
        },
      },
    ],
  };

  return (
    <div className="bg-white py-12 w-full">
      {/* Title Section */}
      <div className="text-center mb-8">

        <h1 className="text-3xl lg:text-4xl font-bold text-center mb-2 ">
          <span className="bg-gradient-to-r from-indigo-600 to-blue-400 text-transparent bg-clip-text">
            Our Trusted Partners
          </span>
        </h1>
      </div>

      {/* Blurred Carousel Wrapper */}
      <div className="relative w-full max-w-screen-xl mx-auto overflow-hidden">
        {/* Left Blur */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />

        {/* Logo Carousel using React Slick */}
        <Slider {...settings} className="w-full">
          {partners.map((partner) => (
            <div key={partner.id} className="flex items-center justify-center">
              <img
                src={partner.src}
                alt={partner.alt}
                className="w-32 h-auto object-contain"
              />
            </div>
          ))}
        </Slider>

        {/* Right Blur */}
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      </div>
    </div>
  );
};

export default Partners;
